import React from 'react';
import './styles.css';
import {lessonsIcon, logoTextWhite} from '../../../../assets/images';
import {homeText} from '../../homeText';

const parseServerDateToMillis = (input?: string | Date | null): number => {
  if (!input) return NaN;
  if (input instanceof Date) return input.getTime();
  const s = input.toString();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, day] = s.split('-').map(Number);
    const localEndOfDay = new Date(y, m - 1, day, 23, 59, 59, 999);
    return localEndOfDay.getTime();
  }
  if (/T00:00:00Z$/.test(s)) {
    const dUtc = new Date(s);
    const y = dUtc.getUTCFullYear();
    const m = dUtc.getUTCMonth();
    const day = dUtc.getUTCDate();
    const localEndOfDay = new Date(y, m, day, 23, 59, 59, 999);
    return localEndOfDay.getTime();
  }

  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) {
    const t = Date.parse(s);
    return Number.isFinite(t) ? t : NaN;
  }
  const t = Date.parse(s + 'Z');
  return Number.isFinite(t) ? t : NaN;
};

interface Props {
  course: any;
  onOpenCourse: () => void;
}

const CoursesCard = React.memo((props: Props) => {
  const {course} = props;
  const dueDate = course?.dueDate
    ? parseServerDateToMillis(course.dueDate)
    : NaN;
  const hasDueDate = Number.isFinite(dueDate);
  const isExpired = hasDueDate && dueDate < Date.now();
  const daysLeft = hasDueDate
    ? Math.max(0, Math.ceil((dueDate - Date.now()) / (1000 * 60 * 60 * 24)))
    : null;
  const progressValue =
    course?.progress != null
      ? Math.min(100, Math.max(0, Number(course.progress)))
      : null;

  return (
    <div
      className={`courses-card ${isExpired ? 'courses-card--expired' : ''}`}
      onClick={isExpired ? undefined : props.onOpenCourse}
      aria-disabled={isExpired}>
      <div className="courses-header">
        <div
          className="courses-thumb"
          style={{
            backgroundImage: course.coursePosterUrl
              ? `url(${course.coursePosterUrl})`
              : `url(${logoTextWhite})`,
            backgroundColor: course.coursePosterUrl
              ? ''
              : 'var(--primary-color-1)',
            backgroundSize: course.coursePosterUrl ? '' : 'auto',
          }}></div>
        <div className="courses-tag_container">
          <span className="courses-tag tag-math">{course.subjectTitle}</span>
        </div>
      </div>
      <h2 className="courses-title">{course.title}</h2>

      {/* <p className="courses-organization_name">{course.organizationName}</p> */}
      <p className="courses-due_date">
        {isExpired
          ? homeText.expired
          : hasDueDate
          ? `${daysLeft} ${homeText.daysLeft(daysLeft)}`
          : homeText.noDueDate}
      </p>
      <div className="courses-lessons_container">
        <img src={lessonsIcon} alt="" />
        <p>
          <span>{course.amountOfLessons}</span>{' '}
          {course.amountOfLessons === 1 ? 'Lesson' : 'Lessons'}
        </p>
      </div>
      {progressValue != null ? (
        <div className="courses-progress_container">
          <div
            className="courses-progress_bar"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={progressValue}>
            <div
              className="courses-progress_fill"
              style={{width: `${progressValue}%`}}
            />
          </div>
          <span className="courses-progress_meta">
            Progress {progressValue === 100 ? 'Completed' : `${progressValue}%`}
          </span>
        </div>
      ) : null}
    </div>
  );
});

export default CoursesCard;
